import React from 'react';
import { components } from 'react-select';
import Loader from 'components/loader';

export default (props) => {
    const className = `${props.className} fm-select__loading-indicator`;
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props} className={className}>
                <Loader type="xsmall" />
            </components.DropdownIndicator>
        )
    );
};
